<div class="gc-header">
  <div class="gc-breadcrumb">
    <ul class="flex">
      <li *ngIf="breadCrumbs">Home<span>/</span></li>
      <li><a>{{breadCrumbs}} </a></li>
    </ul>
  </div>

  <div class="flex align-items-center">
    <div class="gc-notification" (click)="notificationsCount > 0 ? op.toggle($event) : null"
         [ngClass]="notificationsCount > 0 ? 'hover-cursor' : ''">
      <img src="../../../assets/images/notifications-icon.svg" alt="notifications-icon.svg">
      <span *ngIf="notificationsCount">{{notificationsCount}}</span>
    </div>
    <p-overlayPanel #op [showCloseIcon]="true" [style]="{width: '545px'}" styleClass="gc-notification">
      <ng-template pTemplate>
        <p-table [value]="notifications" selectionMode="single" >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="name" id="notification">Notification</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-notification>
            <tr [pSelectableRow]="rowData">
              <td>
                <div class="flex justify-content-between align-items-center">
                  <div class="w-70">
                    <span class="pr-1" style="color: #FF5903;">{{toRecheck}}: </span>
                    <span>{{notification?.message}}</span>
                  </div>
                  <div class="align-right-center">
                    <span class="gc-notify-time">{{formatNotificationDate(notification?.createdAt)}}</span>
                    <em (click)="updateNotifications(notification)" class="pi pi-times m-l-10"></em>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </ng-template>
    </p-overlayPanel>
    <div class="gc-agency-avatar">
      <div  class="align-center">
        <div class="agency-img">
          <img #toggleProfile id="toggle" (click)="profileOptions = !profileOptions" [src]="picture ? picture : defaultUserPicture" alt="user-img">
        </div>
        <span><em class="pi pi-angle-down" (click)="profileOptions = !profileOptions" #menu></em></span>
      </div>
      <div *ngIf="profileOptions" (click)="profileOptions = !profileOptions" class="agency-dropdown">
        <ul>
          <li>
            <div class="flex align-items-center gap-2">
              <div class="agency-img">
                <img [src]="picture ? picture : defaultUserPicture" alt="agency-img">
              </div>
              <div class="w-8rem">
                <p class="gc-agency-name mb-1">{{currentUser?.firstName + ' ' + currentUser?.lastName}}</p>
                <p class="gc-agency-handle">{{RoleEnum[currentUser?.currentUserRole]}}</p>
              </div>
              <div>
                <em class="pi pi-times"></em>
              </div>
            </div>
          </li>
          <li *ngFor="let agency of currentUser.agency_roles" [ngClass]="selectedAgency == agency.agency.agencyID ? 'active' : ''">
            <a>
              <div class="">
              <span class="agency-icon"><img src="../../../assets/images/agency1.png" alt="agency1.png"></span>
                {{agency?.agency?.agencyName}}</div>
              <span><em class="pi pi-angle-right"></em></span>
            </a>
            <div class="agency-roll-dropdown">
              <ul>
                <li *ngFor="let role of agency.roles" (click)="setGlobalRole(agency?.agency?.agencyID, role)" [ngClass]="role === selectedRole && selectedAgency == agency.agency.agencyID ? 'active' : ''">
                  <a>
                    <span>{{RoleEnum[role]}}</span> <em class="pi pi-check" *ngIf="role === selectedRole && selectedAgency == agency.agency.agencyID"></em>
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li (click)="openSidebar()">
            <div class="cursor-pointer flex align-items-center gap-2 justify-content-start">
              <img src="assets/images/preferences.svg" alt="">
              Preferences
            </div>
          </li>
          <li>
            <div class="cursor-pointer flex align-items-center gap-2 justify-content-start">
              <img src="assets/images/version.svg" alt="">
              {{ currentReleaseVersion }}
            </div>
          </li>
          <li *ngIf="totpEnabled">
          <div class="cursor-pointer flex align-items-center gap-2 justify-content-start">
              Setup your TOTP by open Authenticator App and scan this image.
          </div>
        </li>
        <li *ngIf="totpEnabled">
            <div *ngIf="totpEnabled" class="cursor-pointer flex align-items-center gap-2 justify-content-start">
              <img src="{{ qrCodeUrl }}" alt="TOTP code">
            </div>
        </li>
          <li (click)="logOut()">
            <div class="gc-logout-btn">
              <a class="cursor-pointer flex align-items-center gap-2 justify-content-start">
                <span><img src="../../../assets/images/logout.svg" alt="logout.svg"></span>
                <span class="gc-logout-text">Logout</span>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
